import { render, staticRenderFns } from "./DynamicItemRound.vue?vue&type=template&id=622d0ea3&"
import script from "./DynamicItemRound.vue?vue&type=script&lang=js&"
export * from "./DynamicItemRound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports